import React from "react";
import { MpTextField } from "../../../../components";
import { useTranslation } from "../../../../hooks";

interface IProps {
    label?: string
    value: any;
    onChange: (e: React.ChangeEvent<any>) => void;
}

const CardProfileNameTextField = (props: IProps) => {
    const { label, value, onChange } = props;
    const { tc } = useTranslation();

    return (
        <MpTextField
            label={label || tc('phInputField', { fieldName: tc('cardProfileName') })}
            value={value || ''}
            onChange={onChange}
        />
    );
}

export default CardProfileNameTextField;